/**
 * 创建页「最近使用」—— localStorage 记录选择频次。
 * 只排这一行。全部资源不读这份记录。
 */

const STORAGE_KEY = 'genericResourceTypeRecent.v1'
const MAX_ENTRIES = 24

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return {}
    }
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    return {}
  }
}

function writeStore(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map))
  } catch (e) {
    // 隐私模式或配额满时不阻断创建流程
  }
}

/** 记录一次类型选择（创建页选类型时调用） */
export function recordRecentAssetType(assetType) {
  const type = String(assetType || '').trim()
  if (!type) {
    return
  }
  const store = readStore()
  const prev = store[type] || { count: 0, lastUsedAt: 0 }
  store[type] = {
    count: prev.count + 1,
    lastUsedAt: Date.now(),
  }
  writeStore(store)
}

/**
 * 从全量类型中筛出最近使用列表（按频次降序，同频按最近时间）。
 * @param {string[]} typeOptions
 * @param {number} [limit=6]
 */
export function recentAssetTypes(typeOptions, limit = 6) {
  const allowed = new Set((typeOptions || []).map((t) => String(t || '').trim()).filter(Boolean))
  const store = readStore()
  return Object.keys(store)
    .filter((type) => allowed.has(type))
    .sort((a, b) => {
      const da = store[a]
      const db = store[b]
      if (db.count !== da.count) {
        return db.count - da.count
      }
      return db.lastUsedAt - da.lastUsedAt
    })
    .slice(0, limit)
}
